import { createAction, props } from "@ngrx/store"
import { ListSow, ListSowPagination } from "./sow.model"

export const setListSow = createAction(
	'[MR Project Workforce Planning and Function Component] set list sow',
	props<{payload: ListSowPagination}>()
)
export const setListSowLoading = createAction(
	'[MR Project Workforce Planning and Function Component] set loading',
	props<{payload: boolean}>()
)
